export default __webpack_public_path__ + "assets/4171bd04802e915d77a30d2942b65254.png";